import header from "./components/header.js";
import gallery from "./components/galleryModal";
// import fadeIn from "./components/fadeIn";

document.addEventListener("DOMContentLoaded", function(event) {
    new header();
    // new fadeIn();
});
